import React from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import {Switch, Route, Redirect, withRouter} from 'react-router-dom';

import icon from '../../img/icon.png';
import inbox from '../../img/inbox.png';
import '../../styles/header.css'
import axios from "axios";
import { signout } from "../../modules/actions/user";
// import { Action, Logout } from 'react-cognito';
import {setRuntimeVariable} from "../../modules/actions/variable";
import {connect} from "react-redux";
import logo from '../../img/logo.png';

class NavBar extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.showUserInfo = this.showUserInfo.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    onLogout(){
        this.props.dispatch(signout()); //calling action
    //    localStorage.clear();
        // window.location.href='/signin';
    }

    showUserInfo(){
        let that = this; //this는 dashboardBuyer component!
        axios.get('https://spice-api.pearlfall.vercel.app'+`/users/getUser`, this.state)
            .then(function (response) {
                // console.log('show user info',response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    type: response.data.type,
                    username: response.data.username,
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    componentDidMount() {
        this.showUserInfo();
    }

    render() {
        return (
            <div>
                <Navbar color="light" light expand="md">
                    <NavbarBrand href="/">SPICE</NavbarBrand>
                    <img src={logo} style={{"width":"30px", "height":"30px"}}/>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                {
                                    this.state.type === 'Buyer' ?
                                    <NavLink href="/dashboard/buyer">DASHBOARD</NavLink>
                                        : <NavLink></NavLink>
                                }
                            </NavItem>
                            <NavItem>
                                <NavLink href={"/dashboard/profile/"+this.state.username}>MY PROFILE</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="/dashboard/history">HISTORY</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="/dashboard/schedule">SCHEDULE</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="/dashboard/messages/list"><img src={inbox} className="icon"/></NavLink>
                            </NavItem>
                            <NavItem>
                                {this.state.type === 'Seller' ?
                                <NavLink href="/dashboard/request"><img src={icon} className="icon"/></NavLink>
                                    : <NavLink href="/dashboard/response"><img src={icon} className="icon"/></NavLink>
                                }
                            </NavItem>
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    ACCOUNT
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem>
                                        BUT DID
                                    </DropdownItem>
                                    <DropdownItem>
                                        YOU DIE?
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={this.onLogout}>
                                        SIGN OUT
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
    };
}


export default withRouter(connect(mapStateToProps)(NavBar));
